<div class="flex-fill d-flex flex-column">
    <div class="d-flex flex-row flex-fill">
        <div *ngIf="deliveries" [class]="showStackFlyout ? 'col-6' : 'col-12'">
            <div class="card">
                <div class="card-body" style="max-width: 1050px">
                    <dx-form [formData]="filter" appAutofocusForm="partNumber" [colCount]="3" (onEditorEnterKey)="search()">
                        <dxi-item itemType="group">
                            <dxi-item dataField="deliveryId" editorType="dxNumberBox" [label]="{ text: 'Delivery #' }"></dxi-item>
                            <dxi-item
                                dataField="dealerId"
                                editorType="dxSelectBox"
                                [label]="{ text: 'Dealer' }"
                                [editorOptions]="{ items: dealers, valueExpr: 'id', displayExpr: 'companyName' }"
                            ></dxi-item>
                            <dxi-item
                                dataField="driverId"
                                editorType="dxSelectBox"
                                [label]="{ text: 'Driver' }"
                                [editorOptions]="{ items: drivers, valueExpr: 'id', displayExpr: 'name' }"
                            ></dxi-item>
                            <dxi-item
                                dataField="truckId"
                                editorType="dxSelectBox"
                                [label]="{ text: 'Truck' }"
                                [editorOptions]="{ items: trucks, valueExpr: 'id', displayExpr: 'name' }"
                            ></dxi-item>
                            <dxi-item
                                dataField="trailerId"
                                editorType="dxSelectBox"
                                [label]="{ text: 'Trailer' }"
                                [editorOptions]="{ items: trailers, valueExpr: 'id', displayExpr: 'name' }"
                            ></dxi-item>

                            <dxi-item dataField="includeDeleted" editorType="dxCheckBox" [label]="{ text: 'Include Deleted' }"></dxi-item>
                        </dxi-item>
                        <dxi-item itemType="group" [colSpan]="2" [colCount]="2">
                            <dxi-item dataField="scheduledStart" editorType="dxDateBox" [label]="{ text: 'Scheduled From' }"></dxi-item>
                            <dxi-item dataField="scheduledEnd" editorType="dxDateBox" [label]="{ text: 'To' }"></dxi-item>
                            <dxi-item dataField="completedStart" editorType="dxDateBox" [label]="{ text: 'Completed From' }"></dxi-item>
                            <dxi-item dataField="completedEnd" editorType="dxDateBox" [label]="{ text: 'To' }"></dxi-item>
                            <dxi-item
                                dataField="transportPlateId"
                                editorType="dxSelectBox"
                                [label]="{ text: 'Transport Plate' }"
                                [editorOptions]="{ items: transportPlates, valueExpr: 'id', displayExpr: 'name' }"
                            ></dxi-item>
                            <dxi-item itemType="empty"></dxi-item>
                            <dxi-item dataField="vin" [label]="{ text: 'VIN' }"></dxi-item>
                        </dxi-item>
                    </dx-form>
                    <div class="btn-toolbar justify-content-end align-items-center mt-1">
                        <div *ngIf="deliveries" class="me-3">{{ deliveries.length }} {{ deliveries.length === 1 ? 'item found' : 'items found' }}</div>
                        <button type="button" accesskey="s" (click)="search()" class="btn btn-primary">Search</button>
                        <button type="button" (click)="clear()" class="btn btn-secondary ms-2">Clear</button>
                    </div>
                </div>
            </div>
            <div class="m-1 grid-fill" *ngIf="deliveries">
                <dx-data-grid
                    #dataGrid
                    [dataSource]="deliveries"
                    keyExpr="id"
                    [wordWrapEnabled]="true"
                    [columnAutoWidth]="false"
                    [showBorders]="true"
                    (onToolbarPreparing)="onToolbarPreparing($event)"
                    (onExporting)="onExporting($event)"
                >
                    <dxi-column dataField="id" caption="Delivery #" width="80"></dxi-column>
                    <dxi-column dataField="stackCount" caption="Stack #" width="100"></dxi-column>
                    <dxi-column dataField="scheduled" caption="Scheduled" dataType="date" width="100"></dxi-column>
                    <dxi-column dataField="scheduledBy" caption="Scheduled By" width="100"></dxi-column>
                    <dxi-column dataField="stackCompleted" caption="Stack Completed" dataType="date" width="100"></dxi-column>
                    <dxi-column dataField="stackCompletedBy" caption="Stack Completed By" width="100"></dxi-column>
                    <dxi-column dataField="completed" caption="Completed" dataType="date" width="100"></dxi-column>
                    <dxi-column dataField="completedBy" caption="Completed By" width="100"></dxi-column>
                    <dxi-column dataField="deleted" caption="Deleted" dataType="date" width="100"></dxi-column>
                    <dxi-column dataField="deletedBy" caption="Deleted By" width="100"></dxi-column>
                    <dxi-column dataField="driverName" caption="Driver" width="100"></dxi-column>
                    <dxi-column dataField="truckName" caption="Truck" width="100"></dxi-column>
                    <dxi-column dataField="trailerName" caption="Trailer" width="100"></dxi-column>
                    <dxi-column dataField="transportPlateName" caption="Plate" width="100"></dxi-column>
                    <dxi-column dataField="dealerList" caption="Dealers" width="200"></dxi-column>
                    <dxi-column dataField="vinList" caption="VINs" width="200"></dxi-column>
                    <dxi-column width="100"></dxi-column>

                    <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations>
                    <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
                    <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
                    <dxo-filter-row [visible]="true"></dxo-filter-row>
                    <dxo-state-storing [enabled]="true" type="localStorage" storageKey="delivery-history-grid"></dxo-state-storing>
                    <dxo-selection [mode]="'multiple'"></dxo-selection>

                    <div *dxTemplate="let data of 'toolbarButtons'">
                        <button
                            class="btn btn-sm btn-success ms-2"
                            (click)="unComplete()"
                            [disabled]="
                                dataGrid.instance.getSelectedRowsData().length !== 1 ||
                                dataGrid.instance.getSelectedRowsData()[0].deleted ||
                                !dataGrid.instance.getSelectedRowsData()[0].stackCompleted ||
                                dataGrid.instance.getSelectedRowsData()[0].completed
                            "
                        >
                            UnComplete Stack
                        </button>
                        <button
                            class="btn btn-sm btn-success ms-2"
                            (click)="unComplete('delivery')"
                            [disabled]="
                                dataGrid.instance.getSelectedRowsData().length !== 1 ||
                                dataGrid.instance.getSelectedRowsData()[0].deleted ||
                                !dataGrid.instance.getSelectedRowsData()[0].completed
                            "
                        >
                            UnComplete Delivery
                        </button>
                        <button
                            class="btn btn-sm btn-success ms-2"
                            (click)="openStack(dataGrid.instance.getSelectedRowsData()[0])"
                            [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                        >
                            Open
                        </button>
                    </div>
                    <div *dxTemplate="let data of 'toolbarText'">
                        <span *ngIf="deliveries" class="me-3">
                            <strong>
                                {{ dataGrid.instance.totalCount() + ' items' }}
                                {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                            </strong>
                        </span>
                    </div>
                </dx-data-grid>
            </div>
        </div>
        <app-delivery-flyout
            #deliveryFlyout
            [delivery]="openedDelivery"
            [hidden]="!showStackFlyout"
            [readOnly]="isFlyoutReadOnly"
            (onCloseClick)="closeStack()"
            class="col-sm-6 d-flex flex-fill"
        ></app-delivery-flyout>
    </div>
</div>
